import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  Link,
  LinkIcon,
} from '../'
import Styles from './ResolutionText.css'

@CSSModules(Styles, {allowMultiple: true})
export default class AmazonResolutionText extends Component {
  render() {
    return (
      <div>
        <p>
          <Link
            to='https://www.asyousow.org/resolutions/2021/12/10-amazon-report-on-aligning-retirement-plan-options-with-company-climate-goals'
            title='Amazon shareholder resolution'
            xstrong
          >
            More resolution details<LinkIcon/>
          </Link>
        </p>

        <blockquote styleName='company-resolution-blockquote'>
          <p>
            <b>WHEREAS:</b> Shareholders applaud Amazon for adopting ambitious operational climate goals:
          </p>

          <ul>
            <li>
              <p>
                Amazon committed to achieve net-zero carbon emissions by 2040. Including to power operations with 100% renewable energy by 2025.
              </p>
            </li>

            <li>
              <p>
                Shipment Zero: The company’s vision is to make all Amazon shipments net zero carbon, delivering 50% of shipments with net zero carbon by 2030.” Recent actions include ordering a fleet of 100,000 electric delivery vehicles.
              </p>
            </li>

            <li>
              <p>
                Commitment to address UN Sustainable Development Goal 13 on Climate Action.
              </p>
            </li>
          </ul>

          <p>
            While the Company has made significant efforts to address climate change across its operations, data from Securities and Exchange Commission (SEC) filings demonstrates misalignment between the Company’s sustainability goals and investment options offered through the Amazon 401(k) Plan.
          </p>

          <p>
            Every investment fund offered by the Amazon retirement plan, including the default option (holding 52% of employee investments), contains major oil and gas, fossil-fired utilities, coal, pipelines, oil field services, or companies in the agribusiness sector with deforestation risk.
            Image shows Amazon's 401(k) plan scoring poor for fossil fuels and deforestation on As You Sow's scorecard
          </p>

          <p>
            A recent scorecard, produced by investor representative As You Sow, shows that the Amazon retirement plan default option is rated poor due to significant investments in fossil fuel companies and companies with deforestation risk.
          </p>

          <p>
            Amazon’s retirement plan currently offers no diversified equity funds that are low carbon, defined as intentionally avoiding investments in fossil fuels companies, companies with deforestation risk, and companies with high carbon emissions. It offers only one fund screened for environmental/social impact.
          </p>

          <p>
            As a result of these limited options, the vast majority of the $12.8 billion employee retirement dollars invested through the Amazon 401(k) Plan as of December 2020 was invested in funds rated poorly on carbon emissions.
          </p>

          <p>
            Amazon’s investment in high carbon companies through its retirement plan choices directly contradicts the climate reduction actions it has committed to take in its operations, creating cognitive dissonance and reputational risk. This may also make it more difficult to retain employees who are increasingly concerned about catastrophic climate impacts. Amazon Employees for Climate Justice staged a walk-out to publicly criticize the Company’s contribution to climate change. The climate impact of continuing to choose high carbon retirement plan investments options over low carbon choices raises red flags for the Company’s reputation.
          </p>

          <p>
            <b>BE IT RESOLVED:</b> Shareholders request the Board, at reasonable expense and excluding proprietary information, prepare a report reviewing the Company’s retirement plan options with the board’s assessment of how the Company’s current retirement plan options align with its climate action goals.
          </p>

          <p>
            <b>SUPPORTING STATEMENT:</b> Proponent suggests the report include, at Board discretion:
          </p>

          <ul>
            <li>
              <p>
                How Amazon could provide employees with more sustainable investment options such as a default option that is better aligned with global and Company climate goals;
              </p>
            </li>

            <li>
              <p>
                If the Board does not intend to include additional low carbon investment options in its employee retirement plan, a statement of the basis for its decision.
              </p>
            </li>
          </ul>

        </blockquote>
      </div>
    )
  }
}